<div class="queue-utilities" data-layout="row" data-layout-align="space-between center" data-layout-gap="1em">
  <div data-layout="row" data-layout-align="space-between center" data-layout-gap="0.5em">
    <!--Remove and Refer button become visible when any of the checkboxes are selected. Otherwise disabled.-->
    <!-- Remove -->
    <button mat-flat-button color="warn" (click)="removeCompletedFax()" [disabled]="selectedFax.length == 0"
      matTooltip="Remove selected fax(es)" matTooltipPosition="below" matTooltipClass="tooltip">
      <mat-icon class="material-icons">delete</mat-icon>({{ selectedFax.length }})
    </button>
    <!-- Refer -->
    <button mat-flat-button color="vdt-primary" (click)="dialogFax.openReferFaxDialog()"
      [disabled]="selectedFax.length == 0" matTooltip="Refer selected fax(es)" matTooltipPosition="below"
      matTooltipClass="tooltip">
      <mat-icon class="material-icons icon-size-sm">drive_file_move</mat-icon>
      ({{selectedFax.length }})
    </button>
  </div>
  <!-- Refresh -->
  <div data-layout="row" data-layout-align="space-between center">
    <span class="count">Showing: <span class="nowrap">{{ faxesCount }}</span></span>
    <app-refresh (iconClick)="refreshQueue()" [title]="refreshTitleText"></app-refresh>
  </div>
  <!-- Filter -->
  <button mat-icon-button title="Filter queue" (click)="openFilterDialog()" matTooltipClass="multiline-tooltip"
    matTooltip="{{filterBadgeData.text}}">
    <mat-icon matBadge={{filterBadgeData.count}} matBadgeColor="warn" matBadgeSize="small"
      class="material-icons-outlined icon-dark" aria-hidden="false" aria-label="Filter queue"
      [matBadgeHidden]="filterBadgeData.count==0">
      filter_list
    </mat-icon>
  </button>
  <span class="cdk-visually-hidden">
    Notification icon with overlaid badge showing the number {{filterBadgeData.count}}
  </span>
</div>
<cdk-virtual-scroll-viewport name="teamFaxes" itemSize="10" autosize style="height: calc(100vh - 250px)">
  <div *cdkVirtualFor="let item of queues" class="nowrap">
    <app-fax-queue [item]="item" [isSelectable]="true" [canBeLocked]="true"
      (removeFaxes)="removeFaxEvent($event)"></app-fax-queue>
  </div>
</cdk-virtual-scroll-viewport>

<app-dialog-fax #dialogFax (referDialogEvent)="referDialogEvent($event)">
  <ng-template #dialogTitle>Refer Fax</ng-template>
  <ng-template #dialogContent>
    <app-refer-fax></app-refer-fax>
  </ng-template>
</app-dialog-fax>

<!-- dialog content: Filter Faxes -->
<ng-template #filterFaxDialogTemplate>
  <form [formGroup]="dateRangeFaxTeamQueue">
    <!-- <mat-form-field class="full-width" appearance="fill">
      <mat-label>Received Date Range</mat-label>
      <mat-date-range-input [rangePicker]="dateRangeFaxTeamQueuePicker" cdkFocusInitial>
        <input matStartDate placeholder="Start date" formControlName="faxStartDate">
        <input matEndDate placeholder="End date" formControlName="faxEndDate">
      </mat-date-range-input>
      <mat-datepicker-toggle matSuffix [for]="dateRangeFaxTeamQueuePicker"></mat-datepicker-toggle>
      <mat-date-range-picker #dateRangeFaxTeamQueuePicker></mat-date-range-picker>
    </mat-form-field> -->

    <div class="mb-3">
      <lib-vdt-datepicker calendarId="tfqReceivedDateRangePicker" 
        placeholderText="Received Date Range"
        [showDateRange]="true" 
        [(dateRange)]="receivedDateRange" 
        [showTime]="false" 
        [readonlyInput] = "true"
        [styleClass]="'full-width'"
        (dateRangeChange)="dateRangeChanged($event, 'tfqReceivedDates')">
      </lib-vdt-datepicker>
    </div>

    <hr />

    <mat-form-field class="full-width" appearance="fill">
      <mat-label>Work Queue</mat-label>
      <mat-select formControlName="faxQueue" (openedChange)="filterFaxQ.value=''">
        <input matInput placeholder="Search" #filterFaxQ>
        <div *ngFor="let a of faxQueues">
          <mat-option [value]="a.queueId"
            *ngIf="a.queueName.toLowerCase().includes((filterFaxQ.value).toLowerCase())">{{ a.queueName }}</mat-option>
        </div>
      </mat-select>
    </mat-form-field>

  </form>
</ng-template>